import type { ScreeningDocument } from "@/services/api/guardiansv2/types";

function nonEmpty(value: string | null | undefined): boolean {
  return Boolean(value?.trim());
}

/** True when a screening document has checks or outcome copy worth showing. */
export function hasScreeningDisplayContent(screening: ScreeningDocument | null | undefined): boolean {
  if (!screening) return false;
  const checks = screening.checks?.checks ?? [];
  if (checks.length > 0) return true;
  const outcome = screening.outcome;
  if (!outcome) return false;
  return nonEmpty(outcome.title) || nonEmpty(outcome.summary) || nonEmpty(outcome.description);
}

export function screeningListTitle(screening: ScreeningDocument): string {
  const fromOutcome = screening.outcome?.title?.trim();
  if (fromOutcome) return fromOutcome;
  const key = screening.catalogue_key?.trim();
  if (key) return key;
  const subject = screening.subject;
  if (subject?.type === "mission") return "Mission screening";
  return "Task screening";
}

export function screeningListSubtitle(screening: ScreeningDocument): string {
  return screening.outcome?.summary?.trim() || "";
}
